import { SocketEvent } from "../SocketEvent";
import { SocketEventInterface } from "../SocketEventInterface";
import { SocketEventProcessorInterface } from "../SocketEventProcessorInterface";
import Logger from "../../Logger/Logger";
import Environment from "../../Environment/Environment";

class LeftAgencyRoom extends SocketEvent implements SocketEventInterface {

  protected props: any;

  constructor() {
    super();
  }

  public process(props: SocketEventProcessorInterface): void {
    if (Environment.isDevelopment() === true) {
      Logger.log(`Left room: ${props.res.room}`);
    }
  }

}

export { LeftAgencyRoom };
